var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarketplaceSettings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg_sidebar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3230",
    "data-name": "Group 3230",
    transform: "translate(-752 -2276)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1882",
    "data-name": "Rectangle 1882",
    width: 24,
    height: 24,
    transform: "translate(752 2276)",
    fill: "rgba(255,255,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "sidebar_dashboard_icon",
    transform: "translate(755.891 2279)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2963",
    "data-name": "Group 2963",
    transform: "translate(-0.889 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3052",
    "data-name": "Group 3052"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M13434.925-4314.653h-3.485v-9.615a2.793,2.793,0,0,0,1.154-.567,2.726,2.726,0,0,0,.469.311v5.339h1.862v4.531Zm9.611-8.305h-1.623v-1.566a2.963,2.963,0,0,0,.463-.311,2.847,2.847,0,0,0,1.16.57v1.305Zm.639-2.275a1.809,1.809,0,0,1-1.8-1.815,1.808,1.808,0,0,1-1.8,1.815,1.809,1.809,0,0,1-1.8-1.815,1.81,1.81,0,0,1-1.8,1.815,1.808,1.808,0,0,1-1.795-1.815,1.808,1.808,0,0,1-1.8,1.815,1.809,1.809,0,0,1-1.8-1.815,1.81,1.81,0,0,1-1.8,1.815,1.809,1.809,0,0,1-1.8-1.815.3.3,0,0,1,0-.051l2.5-2.9h12.973l2.508,2.946-.014.007A1.808,1.808,0,0,1,13445.175-4325.233Z",
    transform: "translate(-13428.997 4330)",
    fill: "#e8eafd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "svg_4",
    d: "M13.269,24.849h1.1V22.486h-1.1a4.713,4.713,0,0,0-.632-1.436l.739-.739-1.341-1.334-.739.739a4.729,4.729,0,0,0-1.422-.631v-1.1H7.5v1.1a4.7,4.7,0,0,0-1.452.653l-.709-.709L3.995,20.365l.721.721A4.7,4.7,0,0,0,4.1,22.479H3v2.376H4.1a4.709,4.709,0,0,0,.631,1.424l-.739.739,1.339,1.339.739-.739A4.726,4.726,0,0,0,7.5,28.25v1.1H9.87v-1.1a4.725,4.725,0,0,0,1.4-.612l.769.768,1.339-1.339-.757-.757a4.719,4.719,0,0,0,.651-1.46Zm-4.584.768a1.949,1.949,0,1,1,1.949-1.949A1.949,1.949,0,0,1,8.686,25.617Z",
    transform: "translate(3.614 -11.354)",
    fill: "#e8eafd"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketplaceSettings);
export default __webpack_public_path__ + "static/media/marketplace-settings.9f174424bc7e165a2991438d80e592db.svg";
export { ForwardRef as ReactComponent };